import { call, put } from 'redux-saga/effects';
import { replace } from '../../../lib/redux-router';

import services from '../services';
import actions from '../../../actions';
import { setAccessToken } from '../../../utils/access-token-storage';
import Paths from '../../../constants/Paths';

export default function* clerkUserSyncFlow(userData) {
  try {
    console.log('🔄 STEP 1: Starting Clerk user sync:', userData);

    // TEMPORAL: Saltar backend sync para probar el flujo
    console.log('🔄 STEP 2: Skipping backend sync for now...');

    // Simular un access token para compatibilidad
    const clerkToken = localStorage.getItem('clerkToken') || 'clerk-token-placeholder';
    console.log('🔄 STEP 3: Setting access token:', clerkToken.substring(0, 20) + '...');

    // Usar el mismo patrón que el login tradicional
    yield call(setAccessToken, clerkToken);
    console.log('🔄 STEP 4: Dispatching authenticate.success...');
    yield put(actions.authenticate.success(clerkToken));

    console.log('🎉 SUCCESS: Clerk authentication completed!');

    // TODO: Uncomment when backend sync is working
    // const user = yield call(services.clerkSync, userData);

  } catch (error) {
    console.error('❌ ERROR in Clerk sync:', error);
  }
}
